import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

import 'dayjs/locale/de';
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(localizedFormat);

export default dayjs;

export { dayjs };

export const DATE_FORMATS = {
  FILENAME_TIMESTAMP: 'DD-MM-YYYY_HHmmss',

  DAILY_FORMAT: 'DD.MM.YYYY',
  MONTHLY_FORMAT: 'MMMM, YYYY',

  ISO_DATE: 'YYYY-MM-DD',
  ISO_DATETIME: 'YYYY-MM-DD HH:mm:ss',
  DISPLAY_DATE: 'DD.MM.YYYY',
  DISPLAY_DATETIME: 'DD.MM.YYYY HH:mm',

  API_DATE: 'YYYY-MM-DD',
  API_DATETIME: 'YYYY-MM-DDTHH:mm:ss',
};

/**
 * Get current day as string
 * @returns {string} Current day
 */
export const getCurrentDay = () => {
  return dayjs().format('D');
};

/**
 * Get current year as string
 * @returns {string} Current year
 */
export const getCurrentYear = () => {
  return dayjs().format('YYYY');
};

/**
 * Get current month as string
 * @returns {string} Current month (MM)
 */
export const getCurrentMonth = () => {
  return dayjs().format('MM');
};

/**
 * Set locale globally
 * @param {string} locale - Locale code (en, ru, de, etc.)
 */
export const setGlobalLocale = (locale) => {
  dayjs.locale(locale);
};
